class restrictSpecialCharacters {
    constructor() {
        this.restrict = 'A';
        this.require = 'ngModel';
        this.link = (scope, elem, attrs, ngModel) => {
            ngModel.$parsers.push(function (viewValue) {
                var reg = /[\/\\.]/;
                if (!viewValue.match(reg)) {
                    return viewValue;
                }
                var transformedValue = ngModel.$modelValue;
                ngModel.$setViewValue(transformedValue);
                ngModel.$render();
                return transformedValue;
            });
        };
    }

    /**
     * Factory
     * @return {Object}
     */
    static directiveFactory() {
        restrictSpecialCharacters.instance = new restrictSpecialCharacters();
        return restrictSpecialCharacters.instance;
    }
}

export default restrictSpecialCharacters;



/** WEBPACK FOOTER **
 ** ./src/app/directives/common/restrictSpecialCharacters.js
 **/